export const TEXT = {
  CTA: {id: 'home.main.cta', defaultMessage: 'Discover yours'},
} as const;

export const IDS = {
  CTA: 'HomeCtaFixed',
} as const;
